import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
// libraries
import $ from 'jquery';

// material UI
import { Button } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import Tooltip from '@material-ui/core/Tooltip';

import { Editor } from '@tinymce/tinymce-react';
import * as CONSTANTS from '../../constants';
import * as CONFIG from '../../config';
import * as UTILS from '../../utils/utilFunctions';
import ValidatedTextField from '../../generic_components/ValidatedTextField';
import ValidatedDropDown from '../../generic_components/ValidatedDropDown';
import { isEmail } from '../../utils/validators';
import SerialMailAttachment from './SerialMailAttachment';

function isValidMailDomain(email) {
  let isValid = false;
  if (email) {
    const splitEmail = email.split('@');
    if (splitEmail) {
      const domain = splitEmail[1];
      if (CONFIG.allowedDomainsForSerialMail.includes(domain)) isValid = true;
    }
  }

  return isValid;
}

function prepareEmployeesKeyValuePairsWithEmail(employees) {
  const mappedDropDownEntries = [];
  if (employees && employees.length > 0) {
    employees.forEach(employee => {
      // only allow email domains which are specified in the config for serial mail usage
      if (employee.email && isValidMailDomain(employee.email)) {
        const value = employee.id;
        const label = employee.email;
        const mappedEmployee = { value, label };
        mappedDropDownEntries.push(mappedEmployee);
      }
    });
  }
  return mappedDropDownEntries;
}

function prepareEmployeesKeyValuePairs(employees) {
  const mappedDropDownEntries = [];
  if (employees && employees.length > 0) {
    employees.forEach(employee => {
      if (employee.lastname) {
        const value = employee.id;
        const label = `${employee.firstname || ''} ${employee.lastname}`;
        const mappedEmployee = { value, label };
        mappedDropDownEntries.push(mappedEmployee);
      }
    });
  }
  return mappedDropDownEntries;
}
class SerialMailEditorSection extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      formFields: {
        from: { value: '' },
        cc: { value: '' },
        bcc: { value: '' },
        language: { value: 'Deutsch' },
        mailSubject: { value: '' }, // templateSchema.templateHeading
        advisor: { value: '' },
        advisorPosition: { value: '' }
      },
      templateName: 'keine Vorlage',
      isTemplateLoaded: false,
      isSignatureLoaded: false,
      templateContent: '',
      signatureContent: '',
      advisorDropDownContent: [],
      senderDropDownContent: [],
      attachments: []
    };
    this.errorHandling = UTILS.errorHandling.bind(this);
  }

  getSignatureTemplate() {
    const url = CONSTANTS.getSignatureTemplateURL;
    const tokenFromLocalStorage = window.sessionStorage.getItem('token');
    const requestBody = { signatureId: this.props.signatureId };
    $.ajax({
      url,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      headers: { 'x-auth': tokenFromLocalStorage },
      data: JSON.stringify(requestBody),
      timeout: CONFIG.ajaxTimeout
    })
      .done((responseBody, status) => {
        console.log('API loadHistory response body: ', responseBody);
        console.log('API /loadHistory response status: ', status);
        this.setState({
          signatureContent: JSON.parse(
            // JSON.stringify(
            //   '<p><span style="font-size:11.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455">i. A. Monika Rütimann<u></u><u></u></span><br/><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455">Assistentin Markus Theiler<u></u><u></u></span></p><p><b><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455">Jörg Lienert AG<u></u><u></u></span></b><br/><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455">Selektion von Fach- und Führungskräften<u></u><u></u></span><br/><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455">Hirschmattstrasse 15<u></u><u></u></span><br/><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455">Postfach<u></u><u></u></span><br/><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455">6002 Luzern<u></u><u></u></span><br/><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455">Telefon 041 227 80 30<u></u><u></u></span><br/><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455"><a href="mailto:monika.ruetimann@joerg-lienert.ch" target="_blank">monika.ruetimann@joerg-<wbr>lienert.ch</a><u></u><u></u></span></p><p><span style="font-size:11.0pt;font-family:&quot;Calibri&quot;,sans-serif;color:#092455"><a href="http://www.joerg-lienert.ch/" target="_blank"><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif">www.joerg-lienert.ch</span></a></span><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455"><u></u><u></u></span><br/><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455">Luzern, Zug, Zürich, Basel, Bern<u></u><u></u></span></p><p><a href="https://www.linkedin.com/company/joerglienertag" target="_blank"><span style="font-size:11.0pt;font-family:&quot;Calibri&quot;,sans-serif;color:#092455;text-decoration:none"><img border="0" width="30" height="30" style="width:.3125in;height:.3125in" id="m_-6373917284358799478Grafik_x0020_3" src="https://lienert.tiffinger-thiel.de/img/mailSignature/linkedin.jpg" data-image-whitelisted="" class="CToWUd"></span></a><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455">&nbsp;</span><a href="https://www.xing.com/companies/j%C3%B6rglienertagniederlassungluzern" target="_blank"><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455;text-decoration:none"><img border="0" width="30" height="30" style="width:.3125in;height:.3125in" id="m_-6373917284358799478Grafik_x0020_4" src="https://lienert.tiffinger-thiel.de/img/mailSignature/xing.jpg" data-image-whitelisted="" class="CToWUd"></span></a></p>'
            // )
            JSON.stringify(responseBody.templateContent)
          ),
          // signatureContent: JSON.parse(
          //   JSON.stringify(
          //     '<p><span style="font-size:11.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455">i. A. Monika Rütimann<u></u><u></u></span><br/><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455">Assistentin Markus Theiler<u></u><u></u></span></p><p><b><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455">Jörg Lienert AG<u></u><u></u></span></b><br/><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455">Selektion von Fach- und Führungskräften<u></u><u></u></span><br/><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455">Hirschmattstrasse 15<u></u><u></u></span><br/><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455">Postfach<u></u><u></u></span><br/><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455">6002 Luzern<u></u><u></u></span><br/><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455">Telefon 041 227 80 30<u></u><u></u></span><br/><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455"><a href="mailto:monika.ruetimann@joerg-lienert.ch" target="_blank">monika.ruetimann@joerg-<wbr>lienert.ch</a><u></u><u></u></span></p><p><span style="font-size:11.0pt;font-family:&quot;Calibri&quot;,sans-serif;color:#092455"><a href="http://www.joerg-lienert.ch/" target="_blank"><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif">www.joerg-lienert.ch</span></a></span><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455"><u></u><u></u></span><br/><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455">Luzern, Zug, Zürich, Basel, Bern<u></u><u></u></span></p><p><a href="https://www.linkedin.com/company/joerglienertag" target="_blank"><span style="font-size:11.0pt;font-family:&quot;Calibri&quot;,sans-serif;color:#092455;text-decoration:none"><img border="0" width="30" height="30" style="width:.3125in;height:.3125in" id="m_-6373917284358799478Grafik_x0020_3" src="https://lienert.tiffinger-thiel.de/img/mailSignature/linkedin.jpg" data-image-whitelisted="" class="CToWUd"></span></a><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455">&nbsp;</span><a href="https://www.xing.com/companies/j%C3%B6rglienertagniederlassungluzern" target="_blank"><span style="font-size:8.0pt;font-family:&quot;Georgia&quot;,serif;color:#092455;text-decoration:none"><img border="0" width="30" height="30" style="width:.3125in;height:.3125in" id="m_-6373917284358799478Grafik_x0020_4" src="https://lienert.tiffinger-thiel.de/img/mailSignature/xing.jpg" data-image-whitelisted="" class="CToWUd"></span></a></p>'
          //   )
          // ),
          isSignatureLoaded: true
        });
        // this.props.liftUpStateToApp({ showLoadingIndicatorGlobal: false });
      })
      .fail(err => {
        // this.props.liftUpStateToApp({ showLoadingIndicatorGlobal: false });

        this.errorHandling(err, url);
      });
  }

  loadTemplate() {
    const url = CONSTANTS.getTemplateByIdURL;
    const tokenFromLocalStorage = window.sessionStorage.getItem('token');
    const requestBody = { templateId: this.props.templateId };
    $.ajax({
      url,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      headers: { 'x-auth': tokenFromLocalStorage },
      data: JSON.stringify(requestBody),
      timeout: CONFIG.ajaxTimeout
    })
      .done(responseBody => {
        // responseBody, status
        this.setState(prevState => ({
          templateName: responseBody.templateName,
          templateContent: JSON.parse(JSON.stringify(responseBody.templateContent)),
          isTemplateLoaded: true,
          formFields: {
            ...prevState.formFields,
            mailSubject: {
              ...prevState.formFields.mailSubject,
              value: responseBody.templateHeading
            }
          }
        }));
        // this.props.liftUpStateToApp({ showLoadingIndicatorGlobal: false });
      })
      .fail(err => {
        // this.props.liftUpStateToApp({ showLoadingIndicatorGlobal: false });

        this.errorHandling(err, url);
      });
  }

  getEmployeeListByPartnerAPICall() {
    const url = CONSTANTS.getEmployeeListByPartnerURL;
    const tokenFromLocalStorage = window.sessionStorage.getItem('token');
    $.ajax({
      url,
      method: 'POST',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      headers: { 'x-auth': tokenFromLocalStorage },
      timeout: CONFIG.ajaxTimeout
    })
      .done(responseBody => {
        this.setState({
          advisorDropDownContent: prepareEmployeesKeyValuePairs(responseBody),
          senderDropDownContent: prepareEmployeesKeyValuePairsWithEmail(responseBody)
        });
      })
      .fail(err => {
        this.errorHandling(err, url);
      });
  }

  componentDidMount() {
    if (this.props.templateId) this.loadTemplate();
    else this.setState({ isTemplateLoaded: true });
    this.getEmployeeListByPartnerAPICall();
    if (this.props.signatureId) {
      this.getSignatureTemplate();
    }
  }

  liftUpAttachments = attachments => {
    this.setState({ attachments });
  };

  onInputFieldChange = e => {
    const inputFieldValue = e.target.value;
    const inputFieldKey = e.target.id || e.target.name;

    this.setState(prevState => ({
      formFields: {
        ...prevState.formFields,
        [inputFieldKey]: {
          ...prevState.formFields[inputFieldKey],
          value: inputFieldValue
        }
      }
    }));
  };

  handleEditorChange = e => {
    this.setState({
      templateContent: e.target.getContent()
    });
    //  console.log('Content was updated:', e.target.getContent());
  };

  handleEditorSignatureChange = e => {
    this.setState({
      signatureContent: e.target.getContent()
    });
    //  console.log('Content was updated:', e.target.getContent());
  };

  prepareMailBody(mailContent, signatureContent, advisor, advisorPosition) {
    const mappedMailContent = mailContent.replace('$berater$', advisor).replace('$funktion$', advisorPosition);
    const mailBody = `${mappedMailContent}${signatureContent}`;

    return mailBody;
  }

  toBase64 = file => {
    console.log('file', file);
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });
  };

  async mapAttachments(files) {
    if (!files || !(Array.isArray(files) && files.length)) return [];
    const filePathsPromises = [];
    files.forEach(file => {
      filePathsPromises.push(this.toBase64(file));
    });
    const filePaths = await Promise.all(filePathsPromises);
    const mappedFiles = files.map((file, index) => ({ filename: file.name, path: filePaths[index] }));
    return mappedFiles;
  }

  handleSendMailButtonClick = async isTestMail => {
    const mailContent = this.state.templateContent;
    const signatureContent = this.state.signatureContent;

    const attachments = await this.mapAttachments(this.state.attachments);

    // prepare sender
    const selectedSender = this.state.senderDropDownContent.filter(entry => entry.value === this.state.formFields.from.value);
    const senderMailAddress = selectedSender && selectedSender[0] ? selectedSender[0].label : '';

    // prepare advisor
    const selectedAdvisor = this.state.advisorDropDownContent.filter(advisor => advisor.value === this.state.formFields.advisor.value);
    const advisor = selectedAdvisor && selectedAdvisor[0] ? selectedAdvisor[0].label : '';
    const advisorPosition = this.state.formFields.advisorPosition.value || '';
    const serialMail = {
      from: senderMailAddress,
      cc: this.state.formFields.cc.value,
      bcc: this.state.formFields.bcc.value,
      language: this.state.formFields.language.value,
      subject: this.state.formFields.mailSubject.value,
      body: this.prepareMailBody(mailContent, signatureContent, advisor, advisorPosition),
      attachments
    };

    if (this.props.serialMailType === 'candidates') {
      serialMail.candidateIds = this.props.markList.filter(candidate => candidate.mailAddress).map(candidate => candidate.candidateId);
    }
    if (this.props.serialMailType === 'counterParts') {
      serialMail.counterParts = this.props.markList
        .filter(counterPart => counterPart.mailAddress)
        .map(counterPart => ({ counterPartId: counterPart._id, companyId: counterPart.companyId }));
    }
    const validCandidateCount = this.props.markList.length - this.countCandidatesWithoutMailAddress();
    this.props.handleSendMailButtonClick(serialMail, isTestMail, validCandidateCount);
  };

  isValidateFormInput() {
    const countOfCandidates = this.props.markList.length;
    return (
      this.state.formFields.from.value &&
      this.state.formFields.mailSubject.value &&
      countOfCandidates > this.countCandidatesWithoutMailAddress()
    );
  }

  countCandidatesWithoutMailAddress = () =>
    this.props.markList.filter(candidate => !isEmail.isValid(candidate.mailAddress) || !['Frau', 'Herr'].includes(candidate.salutation))
      .length;

  render() {
    const countOfCandidates = this.props.markList.length;
    return (
      <React.Fragment>
        <h6>{`${countOfCandidates} Merklisten insgesamt, davon haben ${this.countCandidatesWithoutMailAddress()} keine valide E-Mail Adresse oder Anrede.`}</h6>
        <div className="row mb-2">
          <div className="col-8">
            <ValidatedDropDown
              label="Absender"
              placeHolderText="Bitte wählen"
              value={this.state.formFields.from.value}
              onChange={this.onInputFieldChange}
              id="from"
              key="from"
              content={this.state.senderDropDownContent}
              fullWidth
            />
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-8">
            <ValidatedTextField
              label="CC"
              value={this.state.formFields.cc.value}
              onChange={this.onInputFieldChange}
              id="cc"
              key="cc"
              fullWidth
            />
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-8">
            <ValidatedTextField
              label="BBC"
              value={this.state.formFields.bcc.value}
              onChange={this.onInputFieldChange}
              id="bcc"
              key="bcc"
              fullWidth
            />
          </div>
        </div>
        <div className="row mb-2">
          <div className="col-4">
            <ValidatedDropDown
              label="Sprache"
              value={this.state.formFields.language.value}
              onChange={this.onInputFieldChange}
              id="language"
              key="language"
              content={['Deutsch', 'Englisch', 'Französisch']}
              fullWidth
            />
          </div>

          <div className="col-4">
            <ValidatedTextField label="Vorlage" value={this.state.templateName} disabled fullWidth />
          </div>
        </div>
        <div className="row mb-5">
          <div className="col-12">
            <ValidatedTextField
              label="Betreff"
              value={this.state.formFields.mailSubject.value}
              onChange={this.onInputFieldChange}
              id="mailSubject"
              key="mailSubject"
              fullWidth
            />
          </div>
        </div>
        <div className="row mt-2 mb-2">
          <div className="col-12">
            <h6>
              Die Anrede wird automatisch generiert und durch den Platzhalter $anrede$ plaziert.{' '}
              <Tooltip title="Weitere Platzhalter: $vorname$ $nachname$ $email$">
                <InfoIcon color="primary" />
              </Tooltip>
            </h6>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            {this.state.isTemplateLoaded && (
              <Editor
                initialValue={this.state.templateContent}
                id="templateContent"
                init={{
                  language_url: '/langs/de.js',
                  branding: false,
                  height: '600',
                  selector: 'textarea',
                  fontsize_formats: '8pt 10pt 11pt 12pt 14pt 16pt 18pt 24pt 36pt',
                  plugins: 'link code lists textcolor colorpicker textpattern imagetools',
                  font_formats:
                    'Arial=arial,helvetica,sans-serif;Georgia=georgia,serif;Times New Roman=times new roman,serif;Courier New=courier new,courier,monospace;Stencil=stencil,arial,sans-serif;Optima nova LT Pro=Optima nova LT Pro',
                  toolbar: 'bold italic | bullist numlist | fontselect |  sizeselect fontsizeselect | forecolor | image',
                  content_style: "body { font-family: Optima nova LT Pro; } @font-face { font-family: 'Optima nova LT Pro'; src: url('/fonts/OptimaNovaLTPro-Regular.otf') format('truetype'); font-weight: normal; font-style: normal; font-display: swap; } @font-face { font-family: 'Optima nova LT Pro'; src: url('/fonts/OptimaNovaLTPro-Bold.otf') format('truetype'); font-weight: bold; font-style: normal; font-display: swap; } @font-face { font-family: 'Optima nova LT Pro'; src: url('/fonts/OptimaNovaLTPro-Demi.otf') format('truetype'); font-weight: normal; font-style: normal; font-display: swap; }"

                }}
                onChange={this.handleEditorChange}
              />
            )}
          </div>
        </div>
        <div className="row mt-2 mb-2">
          <div className="col-4">
            <ValidatedDropDown
              label="Berater"
              value={this.state.formFields.advisor.value}
              onChange={this.onInputFieldChange}
              id="advisor"
              key="advisor"
              content={this.state.advisorDropDownContent}
              fullWidth
            />
          </div>
          <div className="col-4">
            <ValidatedDropDown
              label="Funktion"
              value={this.state.formFields.advisorPosition.value}
              onChange={this.onInputFieldChange}
              id="advisorPosition"
              key="advisorPosition"
              content={[
                '',
                'Assistent',
                'Assistentin',
                'Mandatsleiter',
                'Mandatsleiterin',
                'Niederlassungsleiter',
                'Niederlassungsleiterin',
                'Stv. Geschäftsführer',
                'Stv. Geschäftsführerin',
                'Geschäftsführer',
                'Geschäftsführerin'
              ]}
              fullWidth
            />
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-12">
            {this.state.isSignatureLoaded && (
              <Editor
                initialValue={this.state.signatureContent}
                id="signatureContent"
                key={`${this.props.markList}-${this.props.templateId}`}
                init={{
                  language_url: '/langs/de.js',
                  branding: false,
                  height: '400',
                  selector: 'textarea',
                  fontsize_formats: '8pt 10pt 11pt 12pt 14pt 16pt 18pt 24pt 36pt',
                  plugins: 'link code lists textcolor colorpicker textpattern imagetools',
                  font_formats:
                    'Arial=arial,helvetica,sans-serif;Georgia=georgia,serif;Times New Roman=times new roman,serif;Courier New=courier new,courier,monospace;Stencil=stencil,arial,sans-serif;Optima nova LT Pro=Optima nova LT Pro',
                  toolbar: 'bold italic | bullist numlist | fontselect |  sizeselect fontsizeselect | forecolor | image',
                  // WYSIWIG is rendered in an IFrame, thats why we need to add the Fonts here aswell
                  content_style: "body { font-family: Optima nova LT Pro; } @font-face { font-family: 'Optima nova LT Pro'; src: url('/fonts/OptimaNovaLTPro-Regular.otf') format('truetype'); font-weight: normal; font-style: normal; font-display: swap; } @font-face { font-family: 'Optima nova LT Pro'; src: url('/fonts/OptimaNovaLTPro-Bold.otf') format('truetype'); font-weight: bold; font-style: normal; font-display: swap; } @font-face { font-family: 'Optima nova LT Pro'; src: url('/fonts/OptimaNovaLTPro-Demi.otf') format('truetype'); font-weight: normal; font-style: normal; font-display: swap; }"

                }}
                onChange={this.handleEditorSignatureChange}
              />
            )}
          </div>
        </div>
        <div className="row mt-5">
          <div className="col-12">
            <SerialMailAttachment attachments={this.state.attachments} liftUpAttachments={this.liftUpAttachments} />
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-12 mt-5 text-right">
            <Button onClick={() => this.handleSendMailButtonClick(true)} color="primary" disabled={!this.isValidateFormInput()}>
              Testmail senden
            </Button>
            <Button
              onClick={() => this.handleSendMailButtonClick(false)}
              color="primary"
              variant="contained"
              disabled={!this.isValidateFormInput()}
            >
              Serienmail senden
            </Button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

SerialMailEditorSection.propTypes = {
  markList: PropTypes.object.isRequired,
  templateId: PropTypes.string.isRequired,
  signatureId: PropTypes.string.isRequired,
  handleSendMailButtonClick: PropTypes.func.isRequired,
  serialMailType: PropTypes.string.isRequired
};

export default SerialMailEditorSection;
